(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 52036:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(98229);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ ChangePassword_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/utils/Regex.bs.js
var Regex_bs = __webpack_require__(7618);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/forms/InputField.bs.js
var InputField_bs = __webpack_require__(49188);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/components/library/Notification.bs.js
var Notification_bs = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/bindings/ReactHookForm.bs.js
var ReactHookForm_bs = __webpack_require__(77103);
// EXTERNAL MODULE: ./src/layouts/OnboardingLayout.bs.js
var OnboardingLayout_bs = __webpack_require__(8103);
// EXTERNAL MODULE: ./src/api/PrezzeeSecureClient.bs.js + 13 modules
var PrezzeeSecureClient_bs = __webpack_require__(68213);
;// CONCATENATED MODULE: ./src/components/pages/forgotPassword/ResetPasswordOnboardingStyles.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
var titleStyle = "text-2xl sm:text-40px text-dark-gray text-center lg:text-left mb-4";
var subtitleStyle = "sm:text-xl text-dark-gray text-center lg:text-left pb-5";
var notificationContainer = "pt-4 clear-both";
var formInput = "appearance-none rounded-lg border-2 w-full text-mid-gray leading-tight py-3 px-3 mb-4 outline-none";
var mainContainer = "w-full max-w-md mt-24 mx-auto px-4";
var submitBtn = "mx-auto mt-6 w-48 h-12";
var errorTextStyle = "block text-xs text-left mt-2 text-prezzee-red";
 /* No side effect */ 

// EXTERNAL MODULE: ./src/components/library/OnboardingLayoutCreateAccountButton.bs.js
var OnboardingLayoutCreateAccountButton_bs = __webpack_require__(38099);
;// CONCATENATED MODULE: ./src/components/pages/forgotPassword/ResetPasswordOnboarding.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


















var emailInput = {
    required: {
        value: true,
        message: "Your email is required"
    },
    pattern: {
        value: Regex_bs/* emailRegex */.HN,
        message: "Please enter a valid email address"
    }
};
function ResetPasswordOnboarding(props) {
    var match = react.useState(function() {
        return false;
    });
    var setIsNotificationVisible = match[1];
    var match$1 = react.useState(function() {
        return false;
    });
    var setButtonPressed = match$1[1];
    var buttonPressed = match$1[0];
    var form = ReactHookForm_bs/* useForm */.cI({
        mode: "onTouched"
    }, undefined);
    var onSubmit = react.useCallback(function(data) {
        curry._1(setButtonPressed, function(param) {
            return true;
        });
        setTimeout(function(param) {
            curry._1(setIsNotificationVisible, function(param) {
                return false;
            });
            curry._1(setButtonPressed, function(param) {
                return false;
            });
        }, 30000);
        js_promise/* then_ */.k(function(param) {
            return Promise.resolve(curry._1(setIsNotificationVisible, function(param) {
                return true;
            }));
        }, PrezzeeSecureClient_bs/* resetPassword */.c0(data.email));
        curry._1(form.reset, undefined);
    }, [
        form
    ]);
    return jsx_runtime.jsxs(OnboardingLayout_bs/* make */.S, {
        children: [
            jsx_runtime.jsx(OnboardingLayoutCreateAccountButton_bs/* make */.S, {}),
            jsx_runtime.jsx("div", {
                children: match[0] ? jsx_runtime.jsx(Notification_bs.make, {
                    notificationType: /* NotificationSuccess */ 2,
                    title: "Request successful",
                    description: "Please check your email for password reset instructions"
                }) : null,
                className: notificationContainer
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("h1", {
                        children: util_bs/* ReactStuff.s */.p_.s(props.title),
                        className: titleStyle
                    }),
                    jsx_runtime.jsx("h2", {
                        children: util_bs/* ReactStuff.s */.p_.s("Enter your email below"),
                        className: subtitleStyle
                    }),
                    jsx_runtime.jsxs("form", {
                        children: [
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx((link_default()), {
                                    href: "/forgot-email-address",
                                    prefetch: false,
                                    children: jsx_runtime.jsx("a", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Forgot your email?"),
                                        className: "text-light-gray text-xs"
                                    })
                                }),
                                className: "block text-right"
                            }),
                            jsx_runtime.jsx(InputField_bs/* make */.S, {
                                type_: "email",
                                name: "email",
                                placeholder: "Email",
                                disabled: form.formState.isSubmitting,
                                inputRef: caml_option/* some */.G(curry._1(form.register, emailInput)),
                                error: FormHelpers_bs/* getFieldError */.zQ(form.errors, "email")
                            }),
                            jsx_runtime.jsx("button", {
                                children: util_bs/* ReactStuff.s */.p_.s(form.formState.isSubmitting ? "Submitting..." : "Reset my password"),
                                className: Cn_bs/* make */.S([
                                    submitBtn,
                                    buttonPressed ? Button_bs/* disabled */.JU : Button_bs/* primaryStyle */.vP
                                ]),
                                disabled: buttonPressed
                            })
                        ],
                        onSubmit: curry._2(form.handleSubmit, onSubmit, FormHelpers_bs/* onError */.qQ)
                    })
                ],
                className: mainContainer
            })
        ],
        onboardingKind: /* ShowAppDownload */ 1
    });
}
var Link$1;
var initialInput = {
    email: ""
};
var make = ResetPasswordOnboarding;
var $$default = (/* unused pure expression or super */ null && (ResetPasswordOnboarding));
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/forgotPassword/ChangePassword.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function ChangePassword(props) {
    return jsx_runtime.jsx(make, {
        title: "Forgot your password?"
    });
}
function getServerSideProps(param) {
    if (Belt_Option.isNone(Js_dict.get(param.query, "preview"))) {
        param.res.setHeader("Cache-Control", Constants.ssr_page_cache);
    }
    return {
        props: {}
    };
}
var ChangePassword_bs_make = ChangePassword;
var ChangePassword_bs_$$default = (/* unused pure expression or super */ null && (ChangePassword));
 /* react/jsx-runtime Not a pure module */ 

;// CONCATENATED MODULE: ./src/pages/forgot-password.js
__webpack_require__(14473);

var __N_SSP = true;



/***/ }),

/***/ 93106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE



function ErrorFieldText(props) {
    var error = props.error;
    if (error !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: error,
            className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                "block text-xs text-left mt-1 mb-2 text-prezzee-red",
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(props.className, "")
            ])
        });
    } else {
        return null;
    }
}
var make = ErrorFieldText;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 49188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20859);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92592);
/* harmony import */ var _css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93802);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72491);
/* harmony import */ var _ErrorFieldText_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE








var disabledInput = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_css_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.midGrey */ .Il.midGrey)),
    tl: /* [] */ 0
});
var Styles = {
    disabledInput: disabledInput
};
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(function(props) {
    var error = props.error;
    var readOnly = props.readOnly;
    var disabled = props.disabled;
    var placeholder = props.placeholder;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("input", {
                        ref: props.inputRef,
                        defaultValue: props.defaultValue,
                        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
                            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(props.inputClassName, ""),
                            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(disabled, false) || _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(readOnly, false) ? disabledInput : ""
                        ]),
                        autoComplete: props.autoComplete,
                        autoFocus: props.autoFocus,
                        disabled: disabled,
                        maxLength: props.maxLength,
                        minLength: props.minLength,
                        name: props.name,
                        pattern: props.pattern,
                        placeholder: placeholder,
                        readOnly: readOnly,
                        type: props.type_,
                        onKeyDown: props.onKeyDown,
                        onFocus: props.onFocus,
                        onBlur: props.onBlur,
                        onChange: props.onChange
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("label", {
                        children: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(props.floatingLabel, placeholder)
                    }),
                    _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(props.children, null)
                ],
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
                    _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(props.containerClassName, ""),
                    "inputContainer",
                    _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(error, "") !== "" ? "error" : ""
                ])
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_ErrorFieldText_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                error: error
            })
        ]
    });
});
 /* disabledInput Not a pure module */ 


/***/ }),

/***/ 75897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadAppleApp(props) {
    var baseHref = "https://itunes.apple.com/au/app/prezzee/id1047060902";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref.replace("au", _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_apple_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full ml-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadAppleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 59195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30369);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE






function DownloadGoogleApp(props) {
    var baseHref = "https://play.google.com/store/apps/details?id=com.prezzee.prezzee";
    var country = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var href;
    href = country.TAG === /* Ok */ 0 ? baseHref + ("&gl=" + _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .lowercase_ascii */ .uq(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountryCode */ .i3.getCountryCode(country._0))) : baseHref;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        prefetch: false,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                src: "/images/badge_play_store.svg",
                alt: "Download on the App Store Logo",
                width: 125,
                height: 37,
                className: "w-full mr-1"
            }),
            className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(props.className, "")
        })
    });
}
var Link$1;
var make = DownloadGoogleApp;
 /* Util Not a pure module */ 


/***/ }),

/***/ 88767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25400);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20949);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71434);
// Generated by ReScript, PLEASE EDIT WITH CARE







function $$Notification(props) {
    var notificationType = props.notificationType;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .icon */ .qv(notificationType)
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.title, null, function(title) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(title),
                                className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .titleStyle */ .E3
                            });
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("p", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(props.description),
                            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .descriptionStyle */ .ab
                        }),
                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(props.markdown, null, function(m) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_markdown__WEBPACK_IMPORTED_MODULE_4__/* .Markdown */ .UG, {
                                children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_5__/* .some */ .G(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(m))
                            });
                        })
                    ]
                })
            ],
            className: _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .innerContainer */ .OM
        }),
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S([
            _NotificationStyles_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rootContainer */ .$2(notificationType),
            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .getWithDefault */ .tj(props.className, "")
        ]),
        role: "alert"
    });
}
var make = $$Notification;
 /* Util Not a pure module */ 


/***/ }),

/***/ 71434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rootContainer; },
/* harmony export */   "E3": function() { return /* binding */ titleStyle; },
/* harmony export */   "OM": function() { return /* binding */ innerContainer; },
/* harmony export */   "ab": function() { return /* binding */ descriptionStyle; },
/* harmony export */   "qv": function() { return /* binding */ icon; }
/* harmony export */ });
/* unused harmony exports container, notificationStyle */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20859);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE


var container = "rounded-lg px-4 py-5 max-w-3xl text-left mx-auto";
var notificationStyle = "fill-current h-6 w-6 mr-4";
function rootContainer(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-error-pink"
            ]);
        case /* NotificationInfo */ 1:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-info-blue"
            ]);
        case /* NotificationSuccess */ 2:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-success-green"
            ]);
        case /* NotificationWarning */ 3:
            return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                container,
                "bg-warning-orange"
            ]);
    }
}
function icon(notificationType) {
    switch(notificationType){
        case /* NotificationError */ 0:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("svg", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("mask", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "white"
                        }),
                        id: "mask0",
                        height: "30",
                        width: "30",
                        maskUnits: "userSpaceOnUse",
                        x: "0",
                        y: "0"
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("g", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                            d: "M15 0C6.75 0 0 6.75 0 15C0 23.25 6.75 30 15 30C23.25 30 30 23.25 30 15C30 6.75 23.25 0 15 0ZM22.3477 20.25L20.25 22.3477L15 17.0977L9.75 22.3477L7.65234 20.25L12.9023 15L7.65234 9.75L9.75 7.65234L15 12.9023L20.25 7.65234L22.3477 9.75L17.0977 15L22.3477 20.25Z",
                            fill: "#C20D16"
                        }),
                        mask: "url(#mask0)"
                    })
                ],
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationInfo */ 1:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0C11.0219 0 7.20687 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30ZM15 6.5625C15.7581 6.5625 16.4417 7.01903 16.7322 7.71972C17.0227 8.42041 16.8616 9.22728 16.3257 9.76319C15.7898 10.2991 14.9829 10.4602 14.2822 10.1697C13.5815 9.87916 13.125 9.19556 13.125 8.4375C13.125 7.40234 13.9648 6.5625 15 6.5625ZM13.125 13.125L16.875 13.125V23.4375H13.125L13.125 13.125Z",
                    fill: "#2E5299",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationSuccess */ 2:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM20.7973 9L12.8003 16.9949L9.10428 13.6131L7 15.9122L12.8957 21.3069L23 11.2027L20.7973 9Z",
                    fill: "#25AE88",
                    fillRule: "evenodd"
                }),
                className: notificationStyle,
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
        case /* NotificationWarning */ 3:
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("svg", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("path", {
                    clipRule: "evenodd",
                    d: "M15 0C11.0219 0 7.20688 1.58081 4.39344 4.39344C1.58094 7.20716 0 11.0219 0 15C0 18.9781 1.58081 22.7931 4.39344 25.6066C7.20716 28.4191 11.0219 30 15 30C18.9781 30 22.7931 28.4192 25.6066 25.6066C28.4191 22.7928 30 18.9781 30 15C30 11.0219 28.4192 7.20687 25.6066 4.39344C22.7928 1.58094 18.9781 0 15 0ZM15 23.4375C14.2419 23.4375 13.5583 22.981 13.2678 22.2803C12.9773 21.5796 13.1384 20.7727 13.6743 20.2368C14.2102 19.7009 15.0171 19.5398 15.7178 19.8303C16.4185 20.1208 16.875 20.8044 16.875 21.5625C16.875 22.5977 16.0352 23.4375 15 23.4375ZM16.875 16.875H13.125V6.5625H16.875V16.875Z",
                    fill: "#DC5800",
                    fillRule: "evenodd"
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .make */ .S([
                    notificationStyle,
                    "text-teal-500"
                ]),
                height: "30",
                width: "30",
                viewBox: "0 0 30 30",
                xmlns: "http://www.w3.org/2000/svg"
            });
    }
}
var innerContainer = "flex";
var titleStyle = "font-bold text-lg text-dark-gray pb-1";
var descriptionStyle = "text-base text-dark-gray";
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 38099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Link */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59037);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE





function OnboardingLayoutCreateAccountButton(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("p", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Not registered?"),
                className: "text-light-gray text-sm mr-6"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/register",
                prefetch: false,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("button", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Create an account"),
                    "aria-label": "Register",
                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S([
                        "w-40 h-12 ml-1",
                        _Button_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .primaryOutlineStyle */ .e1
                    ]),
                    type: "button"
                })
            })
        ],
        className: "flex items-center float-right mr-4 lg:mr-10"
    });
}
var Link$1;
var make = OnboardingLayoutCreateAccountButton;
 /* Util Not a pure module */ 


/***/ }),

/***/ 8103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export features */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96533);
/* harmony import */ var _components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30369);
/* harmony import */ var _components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75897);
/* harmony import */ var _components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59195);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE







var features = [
    "Keep all my eGift cards in one place",
    "Fast access from my phone while I shop",
    "Secure digital wallet",
    "Get offers",
    "Send gift cards even faster"
];
var make = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var onboardingKind = props.onboardingKind;
    var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
    var deviseImg;
    deviseImg = match.TAG === /* Ok */ 0 && match._0 === 3 ? {
        width: 448,
        height: 265,
        src: "/images/laptop_wallet.png",
        alt: "Prezzee wallet"
    } : {
        width: 448,
        height: 275,
        src: "/images/prezzee_desktop_wallet.png",
        alt: "Prezzee wallet"
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: typeof onboardingKind === "number" ? onboardingKind !== 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("h2", {
                                    children: [
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Never forget a"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift card again.")
                                    ],
                                    className: "font-semibold text-3xl text-white mb-4 "
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("p", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Buy, send and store ")
                                        }),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("gift cards, all"),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("with a few clicks in the Prezzee App."),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("br", {}),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("strong", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Download for free now.")
                                        })
                                    ],
                                    className: "text-lg text-white font-thin leading-relaxed mb-8"
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadGoogleApp_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                                            className: "mr-3 w-32"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_library_DownloadAppleApp_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
                                            className: "ml-3 w-32"
                                        })
                                    ],
                                    className: "flex"
                                })
                            ],
                            className: ""
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                src: "/images/prezzee_mobile_app.png",
                                alt: "Prezzee iOS and Android mobile applications",
                                width: 448,
                                height: 457,
                                className: "max-w-md w-full h-auto py-6 my-auto"
                            }),
                            className: "flex-grow flex"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("ul", {
                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.ate */ .p_.ate(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(features, function(index, feature) {
                                return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("li", {
                                    children: [
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                                            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                                                src: "/images/icon_tick.svg",
                                                alt: feature,
                                                width: 20,
                                                height: 20
                                            }),
                                            className: "mt-1 mr-4"
                                        }),
                                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("span", {
                                            children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(feature),
                                            className: "block w-full max-w-xs"
                                        })
                                    ],
                                    className: "flex mb-8"
                                }, "index-" + String(index));
                            })),
                            className: "flex-grow text-white text-xl"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: deviseImg.src,
                            alt: deviseImg.alt,
                            width: deviseImg.width,
                            height: deviseImg.height,
                            className: "max-w-md w-full h-auto py-6 mt-auto"
                        })
                    ],
                    className: "px-2 xl:px-10 xxl:px-16 flex flex-col flex-grow"
                }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
                    children: [
                        _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .mapWithIndex */ .Su(onboardingKind._0, function(i, text) {
                            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("h2", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(text),
                                className: "font-bold text-4xl text-white text-center"
                            }, "title" + String(i));
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_components_StaticImage_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
                            src: "/images/presents.svg",
                            alt: "Presents",
                            width: 518,
                            height: 303,
                            className: "w-full pt-20 flex-grow"
                        })
                    ]
                }),
                className: "hidden w-full lg:flex flex-col lg:w-1/3 py-20 pb-5 px-5 bg-prezzee-red"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("div", {
                children: props.children,
                className: "w-full lg:w-2/3 bg-white text-center py-5"
            })
        ],
        className: "flex flex-wrap-reverse w-full"
    });
});
 /* make Not a pure module */ 


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [949,8213,9774,2888,179], function() { return __webpack_exec__(52036); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);